import { withCloseAfterExited } from "@10duke/dukeui";
import {
  default as View,
  RemoveRoleModalProps,
} from "./remove-role-modal-view";

const RemoveRoleModal = withCloseAfterExited<RemoveRoleModalProps>(View);
export default RemoveRoleModal;
